import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MANUAL_REFRESH_IDENTIFIER } from '../../util/constants';
import { ManualResponse, RecordResponse } from '../../models/manual-refresh.interface';

@Component({
    standalone: false,
    selector: 'cva-common-dialog',
    templateUrl: './common-dialog.component.html',
    styleUrl: './common-dialog.component.scss',
    
})
export class CommonDialogComponent {
  @Input() title: string = '';
  @Input() headerIcon: string = '';
  @Input() id!: string;
  @Input() indentifier!: MANUAL_REFRESH_IDENTIFIER;
  @Input() refreshIcon = false;
  @Input() headerClass: string = '';

  @Output() closeDialog = new EventEmitter<void>();
  @Output() dataFetched = new EventEmitter<ManualResponse<RecordResponse>>();

  constructor() { }

  closeModal(): void {
    this.closeDialog.emit();
  }

  patchRefreshedData(data: ManualResponse<RecordResponse>): void {
    this.dataFetched.emit(data);
  }
}
